import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import {
    ANONYM_USER,
    IS_B2B_BIZ_USER,
    IS_CORP_USER,
    IS_DOCUMENTS_DOMAIN,
    IS_MY_TEAM,
    IS_ONPREMISE,
    IS_PAID_USER,
    IS_PHONE_BROWSER,
} from 'reactApp/appHelpers/configHelpers';

// CLOUDWEB-19920
// Улучшение качества фотографии

export const PROMO_ID = 'ai-photo-improve';

export const AI_VIEWER_TOOLBAR_ID = 'ai_viewer_toolbar_id';

const DISABLE_FEATURE = IS_B2B_BIZ_USER || IS_PHONE_BROWSER || IS_DOCUMENTS_DOMAIN || IS_ONPREMISE || IS_MY_TEAM || ANONYM_USER;

export const isAiPhotoImproveEnabled: boolean = !DISABLE_FEATURE && isFeature(PROMO_ID);
export const isAiPhotoImproveAttachesEnabled: boolean = isAiPhotoImproveEnabled && isFeature(`${PROMO_ID}-attaches`);
export const isAiPhotoImprovePublicEnabled: boolean = isAiPhotoImproveEnabled && isFeature(`${PROMO_ID}-public`);

export const fileTypesForAiPhotoImprove: string[] = getFeature('ai-photo-improve-file-exts') || ['png', 'jpg', 'jpeg', 'heic'];
export const fileTypesForAiPhotoImproveMaxSize: number = getFeature('ai-photo-improve-file-max-size') || 10 * 1024 ** 2;

export const aiPhotoImprovePaymium: boolean = isFeature('ai-photo-improve-paymium');
export const aiPhotoImprovePaymiumLimit: number = getFeature('ai-photo-improve-paymium-limit') || 20;
export const aiPhotoImproveFreemiumLimit: number = getFeature('ai-photo-improve-freemium-limit') || 1;
export const aiPhotoImproveClientSideRestictionCheck: boolean = isFeature('ai-photo-improve-client-side-restriction');

/** id промо Попапа - для включения нужно будет включать фичу 3promo-enable-{id} */
export const PROMO_VIEWER_POPUP_ID = 'ai-photo-impr-vw-ppp-promo';
/** Ключ для локалстораджа от попапа */
export const storageKeyForPopup = `${PROMO_VIEWER_POPUP_ID}-2`;
export const isAiImprovePromoViewerEnabled = isFeature(`3promo-enable-${PROMO_VIEWER_POPUP_ID}`);

/** Временной промежуток между показами одной и той же промки, в секундах */
export const showInterval: number = +getFeature(`${PROMO_VIEWER_POPUP_ID}-show-interval`) || 172800;
/** Максимальное количество закрытий промки (на крестик в баннере / на primary кнопку) */
export const closeLimit: number = +getFeature(`${PROMO_VIEWER_POPUP_ID}-close-limit`) || 3;
/** Максимальное количество показов, в которых не взаимодействуют с промкой */
export const showLimit: number = +getFeature(`${PROMO_VIEWER_POPUP_ID}-show-limit`) || 3;

/** id промо Тултипа - для включения нужно будет включать фичу 3promo-enable-{id} */
export const PROMO_TOOLTIP_POPUP_ID = 'ai-photo-impr-vw-tltp-promo';
/** Ключ для локалстораджа от тултипа */
export const storageKeyForTootip = `${PROMO_TOOLTIP_POPUP_ID}-2`;
export const isAiImprovePromoTooltipViewerEnabled = isFeature(`3promo-enable-${PROMO_TOOLTIP_POPUP_ID}`);

/** Временной промежуток между показами одной и той же промки, в секундах */
export const showIntervalTooltip: number = +getFeature(`${PROMO_TOOLTIP_POPUP_ID}-show-interval`) || 172800;
/** Максимальное количество закрытий промки (на крестик в баннере / на primary кнопку) */
export const closeLimitTooltip: number = +getFeature(`${PROMO_TOOLTIP_POPUP_ID}-close-limit`) || 3;
/** Максимальное количество показов, в которых не взаимодействуют с промкой */
export const showLimitTooltip: number = +getFeature(`${PROMO_TOOLTIP_POPUP_ID}-show-limit`) || 3;

export const enableAiImprovePromoPopupAfterImprove: boolean =
    !DISABLE_FEATURE && !IS_CORP_USER && !IS_PAID_USER && isFeature('ai-photo-improve-after-improve');

export const enableAiImprovePromoPopupBeforePublish: boolean =
    !DISABLE_FEATURE && !IS_CORP_USER && !IS_PAID_USER && isFeature('ai-photo-improve-publish');

export const aiImproveTariffsTitle: string =
    getFeature('ai-photo-improve-tariffs-title') || 'Нейросеть улучшит фото — с подпиской Mail Space';
export const aiImprovePaymentTitle: string = getFeature('ai-photo-improve-pay-title') || 'Mail Space: улучшение фото с нейросетью';

export const aiImproveApiPollingMaxCount = getFeature('ai-photo-improve-poll-count') || 24;
